import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import apiClient from "../../../services/apiClient";
import ViewSubsectionDocuments from "./viewSubsectionDocuments";
import { ViewSubsectionBulletPoints } from "./viewSubsectionBulletPoints";
import ViewSubsectionTable from "./viewSubsectionTable";
import ViewSubsectionCalender from "./viewSubsectionCalender";

const CommonSubsectionUI = ({
  language,
  section,
  subsection,
  subsectionRef,
}) => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        setLoading(true);
        const response = await apiClient.post(
          "/section_page/subsection_commoncards/",
          { language, section }
        );
        const data = response.data;
        setSections(data.subsection_cards || []);
      } catch (error) {
        console.error("Error fetching sections data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, [language, section]);

  const fetchContentData = async ({
    subsection,
    filter,
    language,
    section,
  }) => {
    try {
      setLoading(true);
      const response = await apiClient.post(`/section_page/view_subsection/`, {
        subsection,
        section,
        language,
        filter: {
          ...filter,
          section_filter: section,
        },
      });
      const data = response.data;
      return data;
    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {loading && <CircularProgress />}

      {sections.map((value) => (
        <div ref={subsection === value.subsection ? subsectionRef : null}>
          {value.layout === "thumbnail" && (
            <ViewSubsectionDocuments
              {...{ fetchContentData, subsection: value, section, language }}
            />
          )}
          {value.layout === "bulletpoints" && (
            <ViewSubsectionBulletPoints
              {...{ fetchContentData, subsection: value, section, language }}
            />
          )}
          {value.layout === "table" && (
            <ViewSubsectionTable
              {...{ fetchContentData, subsection: value, section, language }}
            />
          )}
          {value.layout === "calendar" && (
            <ViewSubsectionCalender
              {...{ fetchContentData, subsection: value, section, language }}
            />
          )}
        </div>
      ))}
    </Box>
  );
};

export default CommonSubsectionUI;
